// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3q3oD","label":"Radio_label__1aZJC","checkMark":"Radio_checkMark__2UB-Q","disabled":"Radio_disabled__18cg9"};